<template>
    <div class="infertilitet">
        <!-- 使用 Waterfall 组件 -->
        <!-- <Waterfall :items="timelineData"/> -->
        <Waterfall/>
        <el-row v-for="(item, index) in timelineData" :key="index" class="timeline-item" :gutter="20">
            <!-- 图片列 -->
            <el-col :span="12" :order="index % 2 === 0 ? 2 : 1">
                <el-card class="timeline-image-card">
                    <el-image v-if="item.image" :src="item.image" class="timeline-image" alt="timeline image" />
                </el-card>
            </el-col>
            <!-- 文字列 -->
            <el-col :span="12" :order="index % 2 === 0 ? 1 : 2">
                <el-card class="timeline-text">
                    <h2>IN {{ item.year }}</h2>
                    <p class="left-align" v-html="item.text"></p>
                </el-card>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-row :gutter="20">
                    <el-col :span="12" v-for="(i, index) in contentFooter" :key="index">
                        <!-- 修改后的 el-card 添加类名 -->
                        <el-card class="timeline-image-card footer-card">
                            <el-image :src="i.image" class="timeline-image" alt="timeline image" />
                            <div class="image-text">
                                <h4 style="color: #2e7d32;">{{ i.year }}</h4>
                                <p v-if="i.title">{{ i.title }}</p>
                                <p class="left-align" v-if="i.text">{{ i.text }}</p>
                                <h4 v-if="i.name">{{ i.name }}</h4>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import Waterfall from '@/components/waterfall.vue';

export default {
    name: "infertilitetLine",
    components: {
        Waterfall // 注册 Waterfall 组件
    },
    data() {
        return {
            timelineData: [
                {
                    year: "2024",
                    text: "Jag besökte kliniken först då jag haft oregelbunden och utebliven menstruation. För att kunna bli gravid, behövdes detta först regleras och åtgärdas. Min kropp reageradd mycket positivt till behandlingarna och inte nog med en regelbunden menstruation så kändes kroppen mer balanserad och mer energisk med dem veckovisa behandlingarna."+"+Jag har haft missfall tidigare men efter att genomgått dessa behandlingar, lyckades jag bli gravid inom några månader på ett naturligt sätt. Under första trimestern och de sista veckorna av graviditeten genomgick jag akupunktur behandling. Och detta var ett väldigt bra fysiskt och mentalt stöd som ledde till att jag alltid kändes mig avslappnad i kroppen. Behandlingarna hjälpte också mot illamåendet och tröttheten första trimestern. Jag kände mig väl omhändertagen och fick stöd som ökade mitt självförtroende för att kunna genomgå denna resan. Dr. Zhou Ying är väldigt omtänksam och lyhörd. Hon förklarar alltid de olika stegen i processen med gott tålamod, vilket fick gjorde mig trygg. Hon är en väldigt erfaren och ställer alltid passande frågor och gav mig goda råd utöver behandlingarna.Jag är väldigt tacksam för den Kinesiska Kliniken och hjälpen jag fått. Kan bara värmt rekommendera ett besök!",
                    image: require("@/assets/experience/timeImg1.jpg")
                },
                {
                    year: "2023",
                    text: "I started with acupuncture to increase the chances of a natural pregnancy. Me and my partner tried to get pregnant for four months and before I started with the acupuncture treatment. At my first visit I meet with professor Guo who after palpating my pulses started to ask me about different symptom’s which I had but haven’t told him about. That made me really impressed and I got a good feeling about starting the treatment. Preferably on afternoons since his wife Zhou Ying was the expert on fertility treatment. So I did and after 6 weeks of treatment I got ovulation. At the same day I had a treatment with Ying and she put extra acupuncture needles on my back to increase the chances of pregnancy. And this worked. After that cycle I was pregnant. After that I kept going for treatments twice per week to minimize the risk for miscarriage and for help with reducing early pregnancy symptoms.This treatment helped me a lot to not feel afraid and to be calm in the early pregnancy. The pregnancy then went good and everything has been fine.I started with acupuncture again in the end of the pregnancy to help the delivery to start by itself to avoid a medical induced labor. And it seems to be working since the labor started with the water break on the same night as Ying told me that it probably would start. I am so grateful for all the help both getting pregnant and during my pregnancy! I am convinced that the acupuncture helped my body a lot and that its a really good treatment for everyone who want’s to get pregnant or have pregnancy issues. For me the treatment made me feel calm and relaxed and I could enjoy being pregnant since I trusted my body!Thank you!",
                    image: require("@/assets/infertilitet/infertilitet1.jpeg")
                },
                {
                    year: "2022",
                    name: "Antoinette",
                    info: "Thank you!",
                    text: "Jag vill verkligen rekommendera ALLA att få akupunktur hos Ying. En vän berättade hur hon blivit hjälpt och då tog jag kontakt med Ying eftersom jag ville förverkliga min dröm om en bebis. Jag hade gjort tre inseminationsförsök men som tyvärr slutat i tårar och ett tidigt missfall. Ying är supergullig och väldigt professionell. Hon inte bara behandlade mig 2 ggr/vecka i 6 veckor utan gav även råd om andra kompletteringar för att maximera mina möjligheter att bli gravid och behålla min bebis. Hon bryr sig verkligen om och finns där för dig hela vägen. 6 veckor efter min första behandling gjorde hon en inför behandling precis innan jag åkte till kliniken för mitt fjärde försök. Kroppen och hela jag kände mig väldigt redo vilket resulterade i att jag den 25 april 2021 fick uppleva de två strecken på graviditetstestet😊Under min graviditet gick jag på behandlingar för att behålla min bebis och jag mådde väldigt bra hela graviditeten ☺️Den 28 december 2021 01.58 fick jag välkomna min mirakelbebis till världen utanför ❤️ ord kan ej beskriva denna lyckan🍀! jag är så glad för all hjälp jag fått av Ying, finns inte ord tillräckligt för min tacksamhet 🙏🏻 för henne och hennes yrke!Jag vill starkt rekommendera Ying både för hennes varma och omtänksamma personlighet och för hennes proffsiga yrkeskunskap!Oavsett ditt behov eller önskan kan hon hjälpa dig att må bättre. Och om du har samma önskan som jag att få hålla din egna lilla skatt i famnen 9 månader senare så har du allt att vinna på att kontakta Ying!Antoinette",
                    image: require("@/assets/infertilitet/infertilitet2.jpg")
                },
                {
                    year: "2020",
                    name: "Hanna",
                    title: "Tusen tack för all hjälp och stöd!",
                    text: "Jag och min partner fick 3 missfall under det första året som vi försökte få barn. Efter det tredje missfallet kontaktade jag Kinesisk Klinik för att se om akupunktur kunde hjälpa oss att bli gravida och behålla barnet. Jag fick en tre månaders behandling av Ying och hennes man och efter det blev vi gravida igen. Jag fortsatte med akupunktur hos Kinesisk Klinik under större delen av graviditeten och i augusti föddes vår underbara lilla dotter. Jag skulle varmt rekommendera Kinesisk Klinik till alla som har liknande svårigheter med att få barn.",
                    image: require("@/assets/experience/timeImg4.jpg")
                },
                {
                    year: "2019",
                    name: "Emma Sturesdotter",
                    title: "Vårt barn föddes 2019.",
                    text: "Jag har sedan tidig ålder haft fruktansvärda problem med mensvärk, kramper som gjort att jag svimmat och legat totalt däckad i flera timmar. Det har påverkat mitt liv oerhört mycket och jag har otaliga gånger varit tvungen att ta mig hem från jobb, skola, träning och andra tillställningar. Har besökt olika gynekologer genom åren som alla konstaterat att 'inget var fel', fick bara mer och mer smärtstillande utskrivet som ändå inte hjälpte. I samband med att min sambo och jag försökt få barn under en lång period bestämde jag mig för att börja på akupunktur hos Prof.Guo Akupunktur  Klinik. Dels för att få bukt med min mensvärk och dels för att kanske kunna få hjälp med att få barn på naturlig väg (i mitt huvud har jag alltid tänkt att dessa delar hör ihop). Jag fick ett underbart bemötande från första stund och det är ett speciellt lugn som infinner sig när man kliver in genom dörren. Att bli tagen på allvar för sina problem och att någon ser helheten samt faktiskt finner lösningar har varit direkt avgörande för mitt psyke efter alla år med problem. Under den tid jag gått på akupunktur så har inte bara mensvärken blivit bättre, utan jag har även fått mer balans i kroppen och en mer välmående känsla överlag hela månaden.  Och för några veckor sedan så gick drömmen i uppfyllelse.. jag och min sambo väntar äntligen barn💖. Tack vare lyhörd, snäll, kunnig och professionell personal på Prof.Guo Akupunktur Klinik.",
                    image: require("@/assets/experience/timeImg6.jpg")
                }
            ],
            contentFooter: [
                {
                    year: "JULI  8 , 2020 ",
                    title: "Vi har blivit föräldrar",
                    name: "Marija",
                    text: "这里是 2019 年的Exakt ett år efter att vi fick besked om att det inte är säkert att vi kan bli gravida på naturlig väg håller vi vår lilla dotter i famnen. Akupunktur och underbara läkare, professor Guo och doktor Ying har hjälpt oss. Vi vill tacka dem och gärna berätta om vår erfarenhet. Vi rekommenderar den här kliniken varmt, för här hittar man allt på ett ställe: omtanke och personligt bemötande, professionalism, enorm kunskap och skicklighet.",
                    image: require("@/assets/infertilitet/infertilitet3.jpg")
                },
                {
                    year: "JULI  29 , 2014",
                    name:"Maria, 34 år",
                    text: "Vi har försökt få barn i över 2,5 års tid. Det har varit jobbiga år då vi sett kollegor, släktingar och vänner bilda egna familjer. Vi har gjort medicinska undersökningar som visat att allt är som det ska. Orken började ta slut och vi började tänka på IVF behandling. Så kom vi på att vi inte provat akupunktur. Vi bokade in en tid på Swe Kinesisk Klinik hos Dr Ying. Jag började med akupunkturbehandling och det tog bara 3 månader tills jag blev gravid. Det är ett mirakel och helt fantastiskt!",
                    image: require("@/assets/infertilitet/infertilitet4.jpeg")
                },
            ]
        };
    },
};
</script>

<style scoped lang="scss">
/* 容器居中 */
.infertilitet {
    // width: 60%;
    min-width: 1200px; 
    width: 1200px; 
}

/* 时间线项间距 */
.timeline-item {
    margin-bottom: 20px;
    display: flex;
    align-items: stretch; /* 保证两列等高 */
}

/* 文字卡片 */
.timeline-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%; /* 让文字内容填充满 */
}

/* 图片卡片 */
.timeline-image-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
}

/* 图片样式 */
.timeline-image {
    width: 350px; /* 设置固定宽度 */
    height: 400px; /* 设置固定高度 */
    object-fit: cover; /* 确保填充且不会变形 */
}
.left-align {
    text-align: left;
    line-height: 1.6; /* 增加行间距 */
}
.image-text {
    text-align: center;
    padding: 10px;
}

/* 新增样式，设置 footer-card 的宽高 */
.footer-card {
    width: 100%;
    height: 800px; // 可根据实际情况调整高度
    box-sizing: border-box;
    padding: 15px; 
}
@media (max-width: 768px) {
    .infertilitet {
        width: 95%;
        padding: 10px;
    }
    
    .timeline-item {
        flex-direction: column;
        margin-bottom: 15px;
    }
    
    .el-col {
        width: 100% !important;
        margin-bottom: 10px;
    }
    
    .timeline-image {
        width: 100% !important;
        height: 250px !important;
    }
    
    .footer-card {
        height: auto !important;
        margin-bottom: 20px;
    }
    
    .el-row--gutter-20 {
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
    
    .el-col-12 {
        width: 100% !important;
    }
}
</style>